module.exports = __webpack_public_path__ + "img/teasers_7.b1a84b4e.jpg";